import axios from "axios";
import store from "../../app/store";
//import { refreshToken } from "../../pages/login/services/login.service";
import { setToken } from "../../pages/utillity-pages/login/store/auth.slice";
import { message } from "antd";
import { setIsNotifShow, setShowMessage } from "../global-store/global.slice";

const GDPR_APPROVAL_REQUIRED = "GDPR approval required";

const Api = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT
})

Api.interceptors.request.use(async (config) => {
    const token = store.getState().authState.token;
    if (token !== null && !config.headers.has('Authorization')) {
        config.headers.set('Authorization', `Token ${token}`);
    }
    return config;
});

Api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const status = error.response?.status;
      // A user who never approved GDPR signs in again, which shows the approval first.
      const gdprApprovalMissing = status === 403 && error.response?.data?.message === GDPR_APPROVAL_REQUIRED;

      if ((status === 401 || gdprApprovalMissing) && !originalRequest._retry) {
        store.dispatch(setToken(null));
        /*originalRequest._retry = true;
  
        const tokenRefreshed = await refreshToken();
        if (tokenRefreshed) {
          originalRequest.headers.Authorization = `Token ${store.getState().authState.token}`;
          return axios(originalRequest);
        }*/
        if (store.getState().globalState.showMessage) {
          store.dispatch(setShowMessage(false))
          message.warning("Oturum Açma Süreniz Sona Erdi, Tekrar Giriş Yapınız.").then(() => {
            store.dispatch(setShowMessage(true))
          });
        }
        store.dispatch(setIsNotifShow(false))
      }
      return Promise.reject(error);
    }
  );
export default Api;